import {
  Box,
  Flex,
  HStack,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  VStack,
} from "@chakra-ui/react";
import { ChangeEvent, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import moment from "moment";
import { RiSearch2Line } from "react-icons/ri";
import DashboardHeader from "../../../components/common/DashboardHeader";
import Loading from "../../../components/common/Loading";
import TraineeSidenav from "../../../components/trainee/courses/Sidenav";
import SurveyService from "../../../services/admin/survey.service";
import userService from "../../../services/user.service";
import routes from "../../routes";

import rarrow from "../../../img/rarrow.svg";
import view from "../../../img/viewSurveyVector.svg";
import coursesService from "../../../services/courses.service";

export const InitialSurveyPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [allSurveys, setAllSurveys] = useState<Array<object> | any>([]);
  const [filteredSurveys, setFilteredSurveys] = useState<Array<object> | any>(
    []
  );
  const [surveyCreator, setSurveyCreator] = useState("");
  const [requiredId, setReqiredId] = useState();
  const params: any = useParams();
  const courseId: string = params.course_id;
  const courseName: null | string = localStorage.getItem("courseName");

  useEffect(() => {
    coursesService
      .getCourse(params.course_id)
      .then((res) => {
        setReqiredId(res.data.id);
      })
      .catch((err) => console.error(err));
    async function getSurveyCreators() {
      try {
        const res = await SurveyService.getAllSurveys();
        setAllSurveys(res.data);
        setFilteredSurveys(res.data);
        const surveysRes: any = res.data;
        for (const survey of surveysRes) {
          const userRes = await userService.getUserProfile(survey.user_id);
          setSurveyCreator(userRes.data.name);
        }
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    }
    getSurveyCreators();
  }, []);

  useEffect(() => {console.log("")}, [filteredSurveys]);

  const handleClick = (survey_uuid: string) => {
    navigate(routes.SurveyLink(courseId, survey_uuid));
  };

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    if (!searchTerm) {
      setFilteredSurveys(allSurveys);
    } else if (searchTerm) {
      if (allSurveys) {
        const filtered = allSurveys
          .filter((survey: any) => survey.id === requiredId)
          .filter((each: any) => each.title.toLowerCase().includes(searchTerm));
        setFilteredSurveys(filtered);
      }
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box width="100hw">
          <DashboardHeader />
          <Box
            bg="#F9F8F8"
            minHeight="100vh"
            height="auto"
            width="100%"
            pt={"1.5rem"}
          >
            <Flex
              width="90%"
              mx="auto"
              pb="120px"
              pt={["50px", "60px", "60px", "80px"]}
              boxSizing="border-box"
            >
              <TraineeSidenav />
              <VStack width={{ lg: "80%", md: "80%", sm: "95%", base: "95%" }}>
                <HStack width={"100%"} height={"2rem"}>
                  <Text
                    as="span"
                    fontSize={["16px", "20px"]}
                    isTruncated
                    maxWidth={["180px", "200px", "350px", "500px"]}
                  >
                    {courseName && courseName.replaceAll(/"/g, "")}
                  </Text>
                  <Image src={rarrow} />
                  <Text as="span" fontSize={["16px", "20px"]} color={"#616161"}>
                    Survey
                  </Text>
                </HStack>

                <Box
                  width="100%"
                  minHeight="90vh"
                  height="auto"
                  mx="auto"
                  pb={{
                    lg: "200px",
                    md: "150px",
                    sm: "110px",
                    base: "110px",
                  }}
                  px={{
                    lg: "2rem",
                    md: "2rem",
                    sm: "1.8rem",
                    base: "1rem",
                  }}
                  pt={{ lg: "3rem", md: "2.6rem", sm: "2rem", base: "2rem" }}
                  bg="white"
                >
                  <Text
                    color="#1E1E1E"
                    fontSize={{
                      lg: "28px",
                      md: "20px",
                      sm: "18px",
                      base: "18px",
                    }}
                    pb={["20px", "30px"]}
                    fontWeight="600"
                  >
                    Surveys{" "}
                  </Text>
                  <InputGroup
                    color="brand.subtitle"
                    bg="white"
                    borderRadius="12px"
                    width="40%"
                    // placeholder="Search"
                  >
                    <Input
                      height="3rem"
                      placeholder="Search"
                      fontSize={14}
                      size="sm"
                      onChange={(e) => handleSearchChange(e)}
                    />
                    <InputRightElement
                      cursor="pointer"
                      pointerEvents="none"
                      children={<RiSearch2Line color="red" size="1.2rem" />}
                    />
                  </InputGroup>
                  <Box mt="1.4rem" width="100%">
                    {loading ? (
                      <Loading />
                    ) : allSurveys.filter(
                        (survey: any) => survey.id === requiredId
                      ).length === 0 ? (
                      <Box>
                        <Text>No Survey available</Text>
                      </Box>
                    ) : filteredSurveys.filter(
                        (survey: any) => survey.id === requiredId
                      ).length === 0 ? (
                      <Box>
                        <Text>No Survey matching your input</Text>
                      </Box>
                    ) : (
                      filteredSurveys
                        ?.filter((survey: any) => survey.id === requiredId)
                        .map((each: any, index: number) => (
                          <Flex
                            key={index}
                            cursor="pointer"
                            justifyContent="space-between"
                            borderLeft="3px solid"
                            borderColor="#EC3337"
                            alignItems="center"
                            mb="30px"
                            pr="30px"
                            py="1.2rem"
                            boxShadow="base"
                            height="5rem"
                            onClick={() => handleClick(each.uuid)}
                          >
                            <HStack
                              width="63%"
                              alignItems="center"
                              mr="10px"
                              ml="25px"
                            >
                              <Image src={view} height="40px" width="40px" />
                              <Box>
                                <Text
                                  fontWeight="600"
                                  color="#616161"
                                  fontSize="20px"
                                >
                                  {each.title}
                                </Text>
                                <Text
                                  fontWeight="400"
                                  color=" #B9B9B9"
                                  mt="5px"
                                  mb="5px"
                                  fontSize="12px"
                                >
                                  Created by {surveyCreator}
                                </Text>
                                <Text
                                  fontSize="14px"
                                  fontWeight="400"
                                  color=" #B9B9B9"
                                ></Text>
                              </Box>
                            </HStack>
                            <Box>
                              <Text color="#B9B9B9" fontSize="11px">
                                Started {moment(each.start_date).fromNow()}
                              </Text>
                              <Text color="#B9B9B9" fontSize="11px">
                                Due {moment(each.end_date).fromNow()}
                              </Text>
                            </Box>
                          </Flex>
                        ))
                    )}
                  </Box>
                </Box>
              </VStack>
            </Flex>
          </Box>
        </Box>
      )}
    </>
  );
};

export default InitialSurveyPage;
